import React, { useEffect, useState } from "react";
import "../Dynamic/Dashboard.scss";
import PendingReview from "../../assets/images/icons/PendingReview.svg";
import RecentRequestIcon from "../../assets/images/icons/RecentRequest.svg";
import InProcess from "../../assets/images/icons/InProgress.svg";
import User from "../../assets/images/icons/User.svg";
import Cookies from "universal-cookie";
import RecentRequest from "./RecentRequest";
import UnreadMessage from "./UnreadMessage";
import AllRequest from "./AllRequest";
import Constant from "../../Constant";
import { Service } from "../../Service/ApiService";
import { useHistory } from "react-router";
import ClosedIcon from "../../assets/images/icons/ClosedIcon.svg";

const WarehouseDashboard: React.FC = () => {
    const history = useHistory();
    const userName = new Cookies().get("userName");
    const [openRequestCount, setOpenRequestCount] = useState<any>({});
    const [isMessageBoxVisible, setIsMessageBoxVisible] = useState(false);
    const [recentRequestTotalCount, setRecentRequestTotalCount] = useState<number>(0);

    const handleValueChange = (isVisible: boolean) => {
        setIsMessageBoxVisible(isVisible); // Update parent state with the value from the child
    };

    const handleRecentRequestCountChange = (count: number) => {
        setRecentRequestTotalCount(count);
    };

    const [selectedRequestTab, setSelectedRequestTab] = useState<{
        data: string;
        excludeStatus: boolean;
        title: string;
    } | null>({
        data: "RECENT_REQUEST",
        excludeStatus: false,
        title: "Recent Requests"
    });

    useEffect(() => {
     fetchOpenRequestsCountForWarehouse();
     localStorage.setItem("dashboardPrefrence", Constant.Profile.OWNER);
    }, []);
    
    const fetchOpenRequestsCountForWarehouse = async () => {
        const response: any = await Service.fetchOpenRequestsCountForWarehouse();
        setOpenRequestCount(response.data);
    };

    const handleRoute = (tab: string) => {
       history.push(`/master/all-request`, {
            data: tab,
            excludeStatus: false
        });
    }

    const handleTabLoad = (data: string, title: string, excludeStatus = false) => {
        setSelectedRequestTab({
            data,
            excludeStatus,
            title
        });
    };

    return (
        <div className="company-dashboard">
            <div className="container-fluid px-0">
                <div className="company-dashboard__user company-dashboard__user d-flex flex-wrap align-items-center justify-content-between my-3 gap-2 position-relative" >
                    <h4 className="dashboard__user--title px-2">
                        Welcome! {userName}
                    </h4>
                    </div>
                    <div className="company-dashboard__inner pt-2">
                        <div className="row mx-0">
                            <div className="col-12 px-0">
                                <div className="company-dashboard__data owner-data">
                                    <div
                                        className={`company-dashboard__data--card cursor-pointer ${selectedRequestTab?.data === "RECENT_REQUEST" ? "active-card" : ""}`}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleTabLoad("RECENT_REQUEST", "Recent Requests");
                                        }}
                                    >
                                        <img
                                            src={RecentRequestIcon}
                                            alt="RecentRequestIcon"
                                            width={36}
                                            height={34}
                                        />
                                        <div className="d-flex flex-column">
                                            <span className="count" style={{ display: 'flex', alignItems: 'center' }}>
                                                {recentRequestTotalCount}
                                            </span>
                                            <span className="details">Recent Requests</span>
                                        </div>
                                    </div>

                                    <div
                                        className={`company-dashboard__data--card cursor-pointer ${selectedRequestTab?.data === "SEND_TO_WAREHOUSE" ? "active-card" : ""}`}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleTabLoad("SEND_TO_WAREHOUSE", "Pending Review");
                                        }}
                                    >
                                        <img
                                            src={PendingReview}
                                            alt="PendingReviewIcn"
                                            width={68}
                                            height={60}
                                        />
                                        <div className="d-flex flex-column">
                                            <span className="count" style={{ display: 'flex', alignItems: 'center' }}>
                                                {openRequestCount["pendingRequestCount"]}
                                            </span>
                                            <span className="details">Pending Review</span>
                                        </div>
                                    </div>

                                    <div
                                        className={`company-dashboard__data--card cursor-pointer ${selectedRequestTab?.data === "IN_PROCESS, CONFIRMED, IN_STAGE, CONFIRMED_FOR_WAREHOUSE, IN_STAGE_FOR_WAREHOUSE" ? "active-card" : ""}`}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleTabLoad("IN_PROCESS, CONFIRMED, IN_STAGE, CONFIRMED_FOR_WAREHOUSE, IN_STAGE_FOR_WAREHOUSE", "In Process");
                                        }}
                                    >
                                        <img
                                            src={InProcess}
                                            alt="InProcessIcn"
                                            width={68}
                                            height={60}
                                        />
                                        <div className="d-flex flex-column">
                                            <span className="count" style={{ display: 'flex', alignItems: 'center' }}>
                                                {openRequestCount["inProcessRequestCount"]}
                                            </span>
                                            <span className="details">In Process</span>
                                        </div>
                                    </div>

                                    <div
                                        className={`company-dashboard__data--card cursor-pointer ${selectedRequestTab?.data === "REASSIGN_TO_ADMIN, WAREHOUSE_COMPLETED, ADMIN_ACCEPTED_FOR_WAREHOUSE" ? "active-card" : ""}`}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleTabLoad("REASSIGN_TO_ADMIN, WAREHOUSE_COMPLETED, ADMIN_ACCEPTED_FOR_WAREHOUSE", "Awaiting Admin Action");
                                        }}
                                    >
                                        <img
                                            src={User}
                                            alt="UserIcn"
                                            width={68}
                                            height={60}
                                        />
                                        <div className="d-flex flex-column">
                                            <span className="count" style={{ display: 'flex', alignItems: 'center' }}>
                                                {openRequestCount["awaitingActionRequestCount"]}
                                            </span>
                                            <span className="details">Sent to Super Admin</span>
                                        </div>
                                    </div>

                                    <div
                                        className={`company-dashboard__data--card cursor-pointer ${selectedRequestTab?.data === "REJECTED, CLOSED" ? "active-card" : ""}`}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleTabLoad("REJECTED, CLOSED", "Closed");
                                        }}
                                    >
                                        <img
                                            src={ClosedIcon}
                                            alt="ClosedIcn"
                                            width={68}
                                            height={60}
                                        />
                                        <div className="d-flex flex-column">
                                            <span className="count">
                                                {openRequestCount["closedRequestCount"]}
                                            </span>
                                            <span className="details">Closed</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <div className="dashboard--msg-table--container position-relative" style={{ backgroundColor: "#fff" }}>
                                <div className={`dashboard-custom-table-outter m-0 ${isMessageBoxVisible ? "msg-box-open" : ""}`}>
                                    {selectedRequestTab ? (
                                        selectedRequestTab.data === "RECENT_REQUEST" ? (
                                            <div>
                                                <RecentRequest onTotalCountChange={handleRecentRequestCountChange} />
                                            </div>
                                        ) : (
                                            <AllRequest
                                                embedded={true}
                                                statusData={selectedRequestTab.data}
                                                excludeStatus={selectedRequestTab.excludeStatus}
                                                title={selectedRequestTab.title}
                                                //Added key to AllRequest to remount component on tab change and reset filters to default, avoiding stale state issues.
                                                key={`${selectedRequestTab.data}-${selectedRequestTab.excludeStatus}-${selectedRequestTab.title}`}
                                            />
                                        )
                                    ) : (
                                        <RecentRequest onTotalCountChange={handleRecentRequestCountChange} />
                                    )}
                                </div>
                                {/* <div className="position-absolute top-0 end-0 unread-msg-wrapper" style={{ maxWidth: isMessageBoxVisible ? "490px" : "48px" }}>
                                    <UnreadMessage
                                        inventoryCount={openRequestCount["totalInventories"]}
                                        onValueChange={handleValueChange}
                                    />
                                </div> */}
                            </div>
                        </div>
                        
                    </div>
            </div>
        </div>
    );
};

export default WarehouseDashboard;
